import tw, { theme } from 'twin.macro' /* eslint-disable-line */
import BrandButton from '../BrandButton'
import Heading from '../Heading'
import Tag from '../Tag'
import type { TArticlePageHeroProps } from './interface'

export const ArticlepageHero = (props: TArticlePageHeroProps) => {
  const { title, articleType, backLink, backTitle } = props
  return (
    <div tw="flex flex-col items-start justify-end !mx-auto sm:m-0 lg:w-full text-center ">
      <div tw="w-full flex flex-col items-center justify-center">
        <div tw="w-full md:relative flex md:flex-row flex-col justify-center items-center">
          {backLink && backTitle && (
            <BrandButton
              as="a"
              icon="ArrowLeft"
              buttonStyle="hollow"
              variant="black"
              iconPosition="left"
              href={backLink}
              tw="h-min py-16 sm:py-0 !px-0 !w-fit self-start md:absolute md:left-0"
            >
              {backTitle}
            </BrandButton>
          )}
          {articleType && <Tag tw="w-auto m-2 pointer-events-none">{articleType}</Tag>}
        </div>
        <Heading
          as="h1"
          variant="h2"
          tw="border-b border-b-[theme(colors.tertiary[2])] border-solid py-14 uppercase font-semibold text-[theme(colors.tertiary[5])] w-full md:w-4/6"
        >
          {title}
        </Heading>
      </div>
    </div>
  )
}

export default ArticlepageHero
